import React, { FC, ReactNode } from 'react';
import { Box, Flex, Heading, IconButton } from '@amzn/storm-ui';
import useIntl from '@i18n/useIntl';
import useChrome from '@chrome/hooks/useChrome';
import { ChromeKeys } from '@chrome/enums';
import {
  COMBINE_ACCOUNTS_HEADER_KEY,
  COMBINE_ACCOUNTS_CLOSE_KEY,
} from '@features/combine-accounts/constants';

interface CombineAccountsLayoutProps {
  children: ReactNode;
  actionButtons?: ReactNode;
  onClose: () => void;
  titleKey?: string;
}

const CombineAccountsLayout: FC<CombineAccountsLayoutProps> = ({
  children,
  actionButtons,
  onClose,
  titleKey,
}) => {
  const { intl } = useIntl();

  /*
    Mounted here rather than on each page so all five steps of the combine and
    upgrade lane share one declaration and cannot drift apart as steps are added.
  */
  useChrome(ChromeKeys.AccountCombination);

  return (
    <Box
      style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        paddingBlockStart="xsmall"
        paddingBlockEnd="xsmall"
        paddingInlineStart="medium"
        paddingInlineEnd="medium"
        style={{ background: 'white', borderBottom: '1px solid #D9DEE4' }}
      >
        <Flex alignItems="center" columnGap="xsmall">
          <IconButton
            onClick={onClose}
            aria-label={intl.getMessage(COMBINE_ACCOUNTS_CLOSE_KEY)}
            icon="close"
            label={intl.getMessage(COMBINE_ACCOUNTS_CLOSE_KEY)}
            variant="transparent"
          />
          <Heading renderAs="h3">
            {intl.getMessage(titleKey ?? COMBINE_ACCOUNTS_HEADER_KEY)}
          </Heading>
        </Flex>
        {actionButtons}
      </Flex>

      <Box
        flex="1"
        paddingBlockStart="medium"
        paddingBlockEnd="medium"
        paddingInlineStart="medium"
        paddingInlineEnd="medium"
        bgColor="offset"
      >
        <Box style={{ maxWidth: '960px', margin: '0 auto' }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default CombineAccountsLayout;
